import { useRuntimeConfig } from '#imports'

// Composable pour gérer les URLs des assets Laravel (images, fichiers)
export function useDjangoAssets() {
    const config = useRuntimeConfig()

    // Transforme une URL relative en URL complète accessible depuis le navigateur
    function buildAssetUrl(relativePath: string | null | undefined): string | null {
        if (!relativePath) return null

        // Récupérer l'URL configurée pour les assets
        const assetsUrl = config.public.djangoAssetsUrl || config.public.djangoBaseUrl?.replace('/api/v1', '')
        const baseUrl = assetsUrl?.replace(/\/$/, '') || ''

        // Si l'URL est déjà complète, remplacer le domaine par celui configuré
        if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
            try {
                const url = new URL(relativePath)
                // Extraire juste le path (ex: /storage/equipements/photo.jpg)
                return `${baseUrl}${url.pathname}`
            } catch {
                return relativePath
            }
        }

        // Construire l'URL complète avec l'URL publique Laravel
        const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`
        return `${baseUrl}${path}`
    }

    return {
        buildAssetUrl
    }
}

